import { z } from 'zod'
import { Model } from './architecture'
import { Url } from './Url'

export const ListOfUrlValidation = z.object({
  list: z.instanceof(Url, { message: '[ListOfUrl] list is required' }).array(),
})

export class ListOfUrl extends Model {
  static create({ list }: z.infer<typeof ListOfUrlValidation>) {
    ListOfUrlValidation.parse({ list })
    return new ListOfUrl(list)
  }

  static fromJSON(json: ReturnType<ListOfUrl['toJSON']>) {
    return new ListOfUrl(json.list.map(item => Url.create({ value: item })))
  }

  static empty() {
    return new ListOfUrl([])
  }

  constructor(private readonly _list: Url[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  at(index: number) {
    return this._list.at(index)?.value
  }

  toJSON() {
    return { list: this._list.map(item => item.toJSON().value) }
  }
}
